import React from 'react';

// value is the slug
const RadioGroup = ({
  name,
  value,
  options,
  label = '',
  className,
  id,
  disabled,
  handleChange,
  placeholderMessage,
  validationMessage,
  validationError,
  alignLeft,
}) => {
  const onChange = (e) => {
    if (handleChange instanceof Function) handleChange(e.target.value);
  };

  return (
    <>
      <label
        className={`u-weight--semibold ${
          !label.length && label.length < 1 ? 'u-hidden' : ''
        }`}
        htmlFor={name}
      >
        {label || name}
      </label>

      {options.map((option) => {
        const { display, value: optionValue, id } = option;

        return (
          <label
            htmlFor={id}
            className={`c-form__radio-button u-mb-4 ${
              alignLeft ? 'u-ml-0' : ''
            }`}
            key={`radio--${optionValue}`}
          >
            <input
              id={id}
              value={optionValue}
              type="radio"
              name={optionValue}
              onChange={(e) => onChange(e)}
              checked={optionValue === value}
            />
            <span>{display}</span>
          </label>
        );
      })}

      {validationError && (
        <p className="c-form__error u-weight--semibold u-mb-0">
          {validationMessage}
        </p>
      )}
    </>
  );
};

export default RadioGroup;
